import { combineReducers } from "@reduxjs/toolkit";
import projectTaskReducer from "./projectTaskReducer";
import userReducer from "./userReducer";
// import employeeReducer from "../Employee/employeeSlice";
import { inventoryReducers } from "../inventorySlice";
import { employeeReducers }  from "../employeeSlice";
import {financeReducers} from "../financeSlice";
import {customerReducers} from "../projectSlice"
import {projectReducers} from "../projectSlice"
// import projectsReducer from "../projectsSlice";
// import ticketReducer from "../ticketSlice";
import {manageTicketsReducers} from "../ticketManagementSlice";
import taskReducer from "../taskSlice";
import rolesReducer from "../rolesSlice";
import modulesReducer from "../modulesSlice";
import departmentReducer from "../departmentSlice";
import leaveReducer from "../leaveSlice";
import {manageLeaveReducers} from "../manageLeaveSlice";
import { reportsReducers } from "../reportsSlice";

const rootReducer = combineReducers({
  project: projectTaskReducer,
  user: userReducer,
  // employee: employeeReducer,
  ...inventoryReducers,
  ...employeeReducers,
  ...financeReducers,
  ...customerReducers,
  ...projectReducers,
  ...manageLeaveReducers,
  ...manageTicketsReducers,
  ...reportsReducers,
  // projects: projectsReducer,
  // ticket: ticketReducer,
  task: taskReducer,
  roles: rolesReducer,
  modules: modulesReducer,
  department: departmentReducer,
  leave: leaveReducer,
});

export default rootReducer;
